import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const TextContent = ({ contentProps }) => (
  <Typography variant="regular12">{contentProps.text}</Typography>
);

TextContent.propTypes = {
  contentProps: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default memo(TextContent);
